/**
 * Strips common Markdown formatting from text.
 * Converts Markdown-formatted text to plain text suitable for display
 * in article excerpts and other UI elements.
 */
export function stripMarkdown(text: string): string {
  if (!text) return text

  let result = text

  // Remove leading/trailing markdown markers like ***, ***, etc.
  result = result.replace(/^\s*[\*_-]+\s+/, '')  // Remove leading *, _, - with spaces
  result = result.replace(/\s+[\*_-]+\s*$/, '')  // Remove trailing *, _, - with spaces

  // Remove bold/italic formatting: **text**, __text__, ***text***, ___text___, *text*, _text_
  result = result.replace(/\*\*\*(.+?)\*\*\*/g, '$1')  // ***bold italic***
  result = result.replace(/___(.+?)___/g, '$1')         // ___bold italic___
  result = result.replace(/\*\*(.+?)\*\*/g, '$1')       // **bold**
  result = result.replace(/__(.+?)__/g, '$1')           // __bold__
  result = result.replace(/\*(.+?)\*/g, '$1')           // *italic*
  result = result.replace(/_(.+?)_/g, '$1')             // _italic_

  // Remove strikethrough: ~~text~~
  result = result.replace(/~~(.+?)~~/g, '$1')

  // Remove links: [text](url) → text, [text][ref] → text
  result = result.replace(/\[(.+?)\]\(.+?\)/g, '$1')    // [text](url)
  result = result.replace(/\[(.+?)\]\[.+?\]/g, '$1')    // [text][ref]

  // Remove code formatting: `code` → code
  result = result.replace(/`(.+?)`/g, '$1')

  // Remove code blocks (lines starting with 4+ spaces or tab)
  result = result.replace(/^(\s{4,}|\t).+$/gm, '')

  // Remove headings: # text → text
  result = result.replace(/^#+\s+(.+)$/gm, '$1')

  // Remove blockquotes: > text → text
  result = result.replace(/^>\s+(.+)$/gm, '$1')

  // Remove horizontal rules: ---, ***, ___, ----, ****, ____, etc.
  result = result.replace(/^(\*\s?){3,}$/gm, '')
  result = result.replace(/^(-\s?){3,}$/gm, '')
  result = result.replace(/^(_\s?){3,}$/gm, '')
  result = result.replace(/^(\*){3,}$/gm, '')
  result = result.replace(/^(-){3,}$/gm, '')
  result = result.replace(/^(_){3,}$/gm, '')

  // Remove HTML tags
  result = result.replace(/<[^>]+>/g, '')

  // Clean up extra whitespace
  result = result.replace(/\s+/g, ' ').trim()

  return result
}

